// The Open / Caution / Closed cards on the conditions block count
// TRAILS, whichever rows the block lists.
//
// They used to count the rows themselves, so a block in networks mode
// read "Open 1" over an organization with eleven open trails — under
// a home page whose hero, block and stats all said eleven. The cards
// carry no noun, and a reader answers "how many trails are open" from
// them, so they answer that question in both modes. Networks mode
// narrows the trails to the networks it lists.
//
// `usable` is the headline's number, "X of Y trails open": caution is
// open trail (openTrails.js), so it is not the Open card's count.
//
// Imports only plain modules, so the harness can run it in node.
import { rowIsOpen } from '../openTrails.js';

const TONES = ['open', 'caution', 'closed'];

export function trailCounts(siteData, mode, ids = []) {
    const trails = siteData?.trails || [];
    const picked = (ids || []).map(Number);
    let rows = trails;
    if (mode === 'trails') {
        if (picked.length) rows = trails.filter((t) => picked.includes(Number(t.id)));
    } else if (picked.length) {
        const inNetworks = new Set();
        (siteData?.trail_groups || []).forEach((g) => {
            if (g.network_id !== null && picked.includes(Number(g.network_id))) {
                (g.trails || []).forEach((t) => inNetworks.add(Number(t.id)));
            }
        });
        rows = trails.filter((t) => inNetworks.has(Number(t.id)));
    }
    const out = { open: 0, caution: 0, closed: 0, usable: 0 };
    rows.forEach((r) => {
        if (TONES.includes(r.bucket)) out[r.bucket] += 1;
        if (rowIsOpen(r)) out.usable += 1;
    });
    // An organization with networks and no public trails yet still has
    // something to say: fall back to counting what the block lists.
    if (!trails.length && mode !== 'trails') {
        const nets = siteData?.networks || [];
        (picked.length ? nets.filter((n) => picked.includes(Number(n.id))) : nets)
            .forEach((n) => {
                if (TONES.includes(n.bucket)) out[n.bucket] += 1;
                if (rowIsOpen(n)) out.usable += 1;
            });
    }
    return out;
}
